module.exports = __webpack_public_path__ + "static/water_glacier15-1fa7b23a8f50079b601986743c9aa717.jpg";